import { colorMap, ColorNames } from '@/utils/constants';

export const hoverBackground = ({
  muiTheme,
  selector = ':before',
  backgroundColor = colorMap[ColorNames.mediumGray],
  position = {
    top: muiTheme.spacing(-0.9),
    left: muiTheme.spacing(-1.5),
    right: muiTheme.spacing(-1.5),
    bottom: muiTheme.spacing(-0.9),
  },
}: any) => ({
  [`&${selector}`]: {
    content: '""',
    position: 'absolute',
    ...position,
    opacity: 0,
    borderRadius: '4px',
    transition: 'opacity 150ms ease-in-out 0s',
    backgroundColor,
  },
  [`&:hover${selector}`]: {
    opacity: 1,
  },
});
